const customerData = [
  {
    lat: 3.848,
    lng: 11.5021,
    size: 1.0,
    color: "#00ffaa",
    city: "Yaoundé",
    country: "Cameroon",
    flagUrl: "https://flagcdn.com/w320/cm.png",
  },
  {
    lat: -6.7924,
    lng: 39.2083,
    size: 1.0,
    color: "#ffa31a",
    city: "Dar es Salaam",
    country: "Tanzania",
    flagUrl: "https://flagcdn.com/w320/tz.png",
  },
  {
    lat: -22.5609,
    lng: 17.0658,
    size: 1.0,
    color: "#a64dff",
    city: "Windhoek",
    country: "Namibia",
    flagUrl: "https://flagcdn.com/w320/na.png",
  },
  {
    lat: 5.6037,
    lng: -0.187,
    size: 1.0,
    color: "#ff6666",
    city: "Accra",
    country: "Ghana",
    flagUrl: "https://flagcdn.com/w320/gh.png",
  },
  {
    lat: 6.5244,
    lng: 3.3792,
    size: 1.0,
    color: "#ffff66",
    city: "Lagos",
    country: "Nigeria",
    flagUrl: "https://flagcdn.com/w320/ng.png",
  },
  {
    lat: -1.2921,
    lng: 36.8219,
    size: 1.0,
    color: "#ff4d4d",
    city: "Nairobi",
    country: "Kenya",
    flagUrl: "https://flagcdn.com/w320/ke.png",
  },
  {
    lat: 0.3476,
    lng: 32.5825,
    size: 1.0,
    color: "#33ff99",
    city: "Kampala",
    country: "Uganda",
    flagUrl: "https://flagcdn.com/w320/ug.png",
  },
  {
    lat: -4.4419,
    lng: 15.2663,
    size: 1.0,
    color: "#3385ff",
    city: "Brazzaville",
    country: "Congo",
    flagUrl: "https://flagcdn.com/w320/cg.png",
  },
  {
    lat: -3.3614,
    lng: 29.3599,
    size: 1.0,
    color: "#ffd633",
    city: "Bujumbura",
    country: "Burundi",
    flagUrl: "https://flagcdn.com/w320/bi.png",
  },
  {
    lat: 40.7128,
    lng: -74.006,
    size: 1.0,
    color: "#66ccff",
    city: "New York",
    country: "USA",
    flagUrl: "https://flagcdn.com/w320/us.png",
  },
  {
    lat: 48.8566,
    lng: 2.3522,
    size: 1.0,
    color: "#ffcc66",
    city: "Paris",
    country: "France",
    flagUrl: "https://flagcdn.com/w320/fr.png",
  },
  {
    lat: 45.4215,
    lng: -75.6972,
    size: 1.0,
    color: "#ff6666",
    city: "Ottawa",
    country: "Canada",
    flagUrl: "https://flagcdn.com/w320/ca.png",
  },
  {
    lat: 53.3498,
    lng: -6.2603,
    size: 1.0,
    color: "#00ffaa",
    city: "Dublin",
    country: "Ireland",
    flagUrl: "https://flagcdn.com/w320/ie.png",
  },
  {
    lat: -26.2041,
    lng: 28.0473,
    size: 1.0,
    color: "#ffa31a",
    city: "Johannesburg",
    country: "South Africa",
    flagUrl: "https://flagcdn.com/w320/za.png",
  },
  {
    lat: 40.4168,
    lng: -3.7038,
    size: 1.0,
    color: "#a64dff",
    city: "Madrid",
    country: "Spain",
    flagUrl: "https://flagcdn.com/w320/es.png",
  },
  {
    lat: 0.4162,
    lng: 9.4673,
    size: 1.0,
    color: "#ffff66",
    city: "Libreville",
    country: "Gabon",
    flagUrl: "https://flagcdn.com/w320/ga.png",
  },
  {
    lat: -41.2866,
    lng: 174.7756,
    size: 1.0,
    color: "#ff4d4d",
    city: "Wellington",
    country: "New Zealand",
    flagUrl: "https://flagcdn.com/w320/nz.png",
  },
  {
    lat: -8.8383,
    lng: 13.2344,
    size: 1.0,
    color: "#33ff99",
    city: "Luanda",
    country: "Angola",
    flagUrl: "https://flagcdn.com/w320/ao.png",
  },
  {
    lat: -17.8252,
    lng: 31.0335,
    size: 1.0,
    color: "#3385ff",
    city: "Harare",
    country: "Zimbabwe",
    flagUrl: "https://flagcdn.com/w320/zw.png",
  },
  {
    lat: -13.9626,
    lng: 33.7741,
    size: 1.0,
    color: "#ffd633",
    city: "Lilongwe",
    country: "Malawi",
    flagUrl: "https://flagcdn.com/w320/mw.png",
  },
  {
    lat: -15.3875,
    lng: 28.3228,
    size: 1.0,
    color: "#66ccff",
    city: "Lusaka",
    country: "Zambia",
    flagUrl: "https://flagcdn.com/w320/zm.png",
  },
  {
    lat: 25.2769,
    lng: 51.52,
    size: 1.0,
    color: "#ffcc66",
    city: "Doha",
    country: "Qatar",
    flagUrl: "https://flagcdn.com/w320/qa.png",
  },
  {
    lat: 25.2048,
    lng: 55.2708,
    size: 1.0,
    color: "#ff6666",
    city: "Dubai",
    country: "UAE",
    flagUrl: "https://flagcdn.com/w320/ae.png",
  },
  {
    lat: 26.0667,
    lng: 50.5577,
    size: 1.0,
    color: "#00ffaa",
    city: "Manama",
    country: "Bahrain",
    flagUrl: "https://flagcdn.com/w320/bh.png",
  },
  {
    lat: 23.5859,
    lng: 58.4059,
    size: 1.0,
    color: "#ffa31a",
    city: "Muscat",
    country: "Oman",
    flagUrl: "https://flagcdn.com/w320/om.png",
  },
  {
    lat: 18.1096,
    lng: -77.2975,
    size: 1.0,
    color: "#a64dff",
    city: "Kingston",
    country: "Jamaica",
    flagUrl: "https://flagcdn.com/w320/jm.png",
  },
  {
    lat: 10.6918,
    lng: -61.2225,
    size: 1.0,
    color: "#ffff66",
    city: "Port of Spain",
    country: "Trinidad and Tobago",
    flagUrl: "https://flagcdn.com/w320/tt.png",
  },
  {
    lat: 13.2528,
    lng: -61.1971,
    size: 1.0,
    color: "#ff4d4d",
    city: "Kingstown",
    country: "St. Vincent and the Grenadines",
    flagUrl: "https://flagcdn.com/w320/vc.png",
  },
  {
    lat: 59.9139,
    lng: 10.7522,
    size: 1.0,
    color: "#33ff99",
    city: "Oslo",
    country: "Norway",
    flagUrl: "https://flagcdn.com/w320/no.png",
  },
  {
    lat: 60.1699,
    lng: 24.9384,
    size: 1.0,
    color: "#3385ff",
    city: "Helsinki",
    country: "Finland",
    flagUrl: "https://flagcdn.com/w320/fi.png",
  },
  {
    lat: -1.9403,
    lng: 29.8739,
    size: 1.0,
    color: "#ffd633",
    city: "Kigali",
    country: "Rwanda",
    flagUrl: "https://flagcdn.com/w320/rw.png",
  },
  {
    lat: -25.8919,
    lng: 32.6051,
    size: 1.0,
    color: "#66ccff",
    city: "Maputo",
    country: "Mozambique",
    flagUrl: "https://flagcdn.com/w320/mz.png",
  },
  {
    lat: 2.0469,
    lng: 45.3182,
    size: 1.0,
    color: "#ffcc66",
    city: "Mogadishu",
    country: "Somalia",
    flagUrl: "https://flagcdn.com/w320/so.png",
  },
  {
    lat: 4.8594,
    lng: 31.5713,
    size: 1.0,
    color: "#ff6666",
    city: "Juba",
    country: "South Sudan",
    flagUrl: "https://flagcdn.com/w320/ss.png",
  },
  {
    lat: 5.3599,
    lng: -4.0083,
    size: 1.0,
    color: "#00ffaa",
    city: "Abidjan",
    country: "Côte d'Ivoire",
    flagUrl: "https://flagcdn.com/w320/ci.png",
  },
  {
    lat: 14.7167,
    lng: -17.4677,
    size: 1.0,
    color: "#ffa31a",
    city: "Dakar",
    country: "Senegal",
    flagUrl: "https://flagcdn.com/w320/sn.png",
  },
  {
    lat: 8.484,
    lng: -13.2299,
    size: 1.0,
    color: "#a64dff",
    city: "Freetown",
    country: "Sierra Leone",
    flagUrl: "https://flagcdn.com/w320/sl.png",
  },
  {
    lat: -35.2809,
    lng: 149.13,
    size: 1.0,
    color: "#ffff66",
    city: "Canberra",
    country: "Australia",
    flagUrl: "https://flagcdn.com/w320/au.png",
  },
  {
    lat: 50.8503,
    lng: 4.3517,
    size: 1.0,
    color: "#ff4d4d",
    city: "Brussels",
    country: "Belgium",
    flagUrl: "https://flagcdn.com/w320/be.png",
  },
  {
    lat: 55.6761,
    lng: 12.5683,
    size: 1.0,
    color: "#33ff99",
    city: "Copenhagen",
    country: "Denmark",
    flagUrl: "https://flagcdn.com/w320/dk.png",
  },
  {
    lat: 41.9028,
    lng: 12.4964,
    size: 1.0,
    color: "#3385ff",
    city: "Rome",
    country: "Italy",
    flagUrl: "https://flagcdn.com/w320/it.png",
  },
  {
    lat: 28.6139,
    lng: 77.209,
    size: 1.0,
    color: "#ffd633",
    city: "New Delhi",
    country: "India",
    flagUrl: "https://flagcdn.com/w320/in.png",
  },
];

export { customerData };
